<div>
  <mat-form-field appearance="fill">
    <input matInput [matDatepicker]="picker"
           (dateChange)="selectedDate.emit($event.value)" [(ngModel)]="date">
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>
